import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import { useWindowDimensions } from "../../components/windowDimensions";
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const ViewPDF = (props) => {

  const [numPages, setNumPages] = useState(null);

  const { viewPdfModal, setViewPdfModal, resumePdf, setResumePdf } = props;
  const {width}=useWindowDimensions();

  const onDocumentLoadSuccess=({ numPages }) => {
    setNumPages(numPages);
  }

  const onClose = () => {
    setViewPdfModal(false);
    setResumePdf(null);
  };

  return (
    <Modal
      visible={viewPdfModal}
      centered
    //   closable={false}
      onOk={onClose}
      onCancel={onClose}
      footer={null}
    //   bodyStyle={{ height:"80vh" }}
    >
      <div className='jdPdf' style={{height:'80vh',margin:"1.5rem 0 0.5rem 0",}}>
        {/* {width > 700 ? (
          <iframe
            src={`${resumePdf}#view=Stretch&toolbar=0`}
            style={{ height: "80vh" }}
          ></iframe>
        ) : ( */}
          <Document
            file={resumePdf}
            width="100%"
            height="100%"
            onLoadSuccess={onDocumentLoadSuccess}
          >
            {Array.from(new Array(numPages), (el, index) => (
                <Page key={`page_${index + 1}`} pageNumber={index + 1} />
            ))}          
          </Document>
        {/* )} */}
      </div>
    </Modal>
  );
};

export default ViewPDF;